import "/opt/build/repo/site/sentry.client.config.js";
import { init } from 'astro/virtual-modules/prefetch.js';init()